import React from 'react'
import styles from './Padding.module.scss'

type Size = '0' | '1' | '2' | '3' | '4' | '5' | '6' | '8' | '10' | '12'

interface PaddingProps {
  children: React.ReactNode
  top?: Size
  right?: Size
  bottom?: Size
  left?: Size
  x?: Size
  y?: Size
  all?: Size
  className?: never
}

const map: Record<string, Record<Size, string>> = {
  all:    { '0': styles.p0, '1': styles.p1, '2': styles.p2, '3': styles.p3, '4': styles.p4, '5': styles.p5, '6': styles.p6, '8': styles.p8, '10': styles.p10, '12': styles.p12 },
  x:      { '0': styles.px0, '1': styles.px1, '2': styles.px2, '3': styles.px3, '4': styles.px4, '5': styles.px5, '6': styles.px6, '8': styles.px8, '10': styles.px10, '12': styles.px12 },
  y:      { '0': styles.py0, '1': styles.py1, '2': styles.py2, '3': styles.py3, '4': styles.py4, '5': styles.py5, '6': styles.py6, '8': styles.py8, '10': styles.py10, '12': styles.py12 },
  top:    { '0': styles.pt0, '1': styles.pt1, '2': styles.pt2, '3': styles.pt3, '4': styles.pt4, '5': styles.pt5, '6': styles.pt6, '8': styles.pt8, '10': styles.pt10, '12': styles.pt12 },
  right:  { '0': styles.pr0, '1': styles.pr1, '2': styles.pr2, '3': styles.pr3, '4': styles.pr4, '5': styles.pr5, '6': styles.pr6, '8': styles.pr8, '10': styles.pr10, '12': styles.pr12 },
  bottom: { '0': styles.pb0, '1': styles.pb1, '2': styles.pb2, '3': styles.pb3, '4': styles.pb4, '5': styles.pb5, '6': styles.pb6, '8': styles.pb8, '10': styles.pb10, '12': styles.pb12 },
  left:   { '0': styles.pl0, '1': styles.pl1, '2': styles.pl2, '3': styles.pl3, '4': styles.pl4, '5': styles.pl5, '6': styles.pl6, '8': styles.pl8, '10': styles.pl10, '12': styles.pl12 },
}

export const Padding: React.FC<PaddingProps> = ({
  children, top, right, bottom, left, x, y, all,
}) => (
  <div className={[
    all && map.all[all],
    x && map.x[x],
    y && map.y[y],
    top && map.top[top],
    right && map.right[right],
    bottom && map.bottom[bottom],
    left && map.left[left],
  ].filter(Boolean).join(' ')}>
    {children}
  </div>
)
